/* The service context and the hook that reads it, with no dependency on how the
   services get built.

   Split out of ServiceContext.tsx because that file has to import msalConfig to
   decide between mock and SharePoint providers, and msalConfig touches `window`
   at module scope. That made the context object itself unreachable from
   anywhere without a DOM — including a render test, whose entire job is to put
   mock providers behind a screen and which never wanted MSAL in the first
   place.

   ServiceContext.tsx re-exports both of these, so nothing that already imports
   from there needs to change. */

import { createContext, useContext } from 'react';
import type { ILedgerServices } from './IServices';

export const ServiceContext = createContext<ILedgerServices | null>(null);

export function useServices(): ILedgerServices {
  const services = useContext(ServiceContext);
  if (!services) throw new Error('useServices outside ServiceProvider');
  return services;
}
